import { makeCompoundContext } from "../../../functional/compoundContext";
export const [CarouselProvider, useCarouselContext] = makeCompoundContext("Carousel");
export const [CarouselViewportProvider, useCarouselViewportContext] = makeCompoundContext("CarouselViewport");
export const [CarouselSlidesProvider, useCarouselSlidesContext] = makeCompoundContext("CarouselSlides");
export { useCarouselReducer } from "./hooks";
//# sourceMappingURL=index.js.map